import { z } from 'zod'

export const millsheetStatusSchema = z.enum(['completed', 'unset'])
export type MillsheetStatus = z.infer<typeof millsheetStatusSchema>

export const millsheetStatusLabels = {
  completed: '入力済',
  unset: '未入力',
}

export const millsheetStatusOptions = Object.entries(millsheetStatusLabels).map(([key, label]) => ({
  value: key,
  label,
}))

export const millsheetStatusColors: Record<MillsheetStatus, string> = {
  completed: 'green',
  unset: 'gray',
}
